import React from "react";
import dayjs from "dayjs";
import {
  AmountCommodityColumn,
  SessionTotalAmountColumn,
  sortByTotalAmount,
  TotalAmountColumn,
  TotalCommodityAmountColumn,
} from "./CustomColumnRender";
import { DRIVER_OPERATION_TYPE } from "./data";
import getFormatedFloat from "../../../../Utils/getFormatedFloat";

const tripColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Trip ID
      </div>
    ),
    dataIndex: "tripId",
    sorter: (a, b) => a.tripId - b.tripId,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date
      </div>
    ),
    dataIndex: "submittedAt",
    sorter: (a, b) => a.submittedAt.localeCompare(b.submittedAt),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray py-1">
        {text ? dayjs(text).format("DD-MM-YYYY") : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Distance Covered
      </div>
    ),
    dataIndex: "distance",
    sorter: (a, b) => a.distance - b.distance,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text ? `${getFormatedFloat(text)} Km` : "--"}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Energy Consumed
  //     </div>
  //   ),
  //   dataIndex: "id",
  //   // sorter: (a, b) => a.tripId - b.tripId,
  //   render: (text, record) => <EnergyConsumedColumn record={record} />,
  // },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Amount/Energy Consumed
  //     </div>
  //   ),
  //   dataIndex: "id",
  //   // sorter: (a, b) => a.tripId - b.tripId,
  //   render: (text, record) => <AmountPerEnergyConsumedColumn record={record} />,
  // },
  //   {
  //     title: () => (
  //       <div className="font-normal font-aileron text-10 text-dark-gray">
  //         Commodity
  //       </div>
  //     ),
  //     dataIndex: "tripId",
  //     render: (text, record) => <CommodityColumn payment={record} />,
  //   },
  //   {
  //     title: () => (
  //       <div className="font-normal font-aileron text-10 text-dark-gray">
  //         Total Weight
  //       </div>
  //     ),
  //     dataIndex: "tripId",
  //     render: (text, record) => <WeightCollectedColumn payment={record} />,
  //   },
  //   {
  //     title: () => (
  //       <div className="font-normal font-aileron text-10 text-dark-gray">
  //         Rate
  //       </div>
  //     ),
  //     dataIndex: "tripId",
  //     render: (text, record) => <RateColumn payment={record} />,
  //   },

  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Amount/Commodity Collected
      </div>
    ),
    dataIndex: "tripId",
    render: (text, record) => <AmountCommodityColumn payment={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Commodity Amount
      </div>
    ),
    dataIndex: "tripId",
    render: (text, record) => <TotalCommodityAmountColumn record={record} />,
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Amount
      </div>
    ),
    dataIndex: "tripId",
    sorter: (a, b) => sortByTotalAmount(a, b),
    render: (text, record) => <TotalAmountColumn record={record} />,
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Status
  //     </div>
  //   ),
  //   dataIndex: "paymentStatus",
  //   sorter: (a, b) => a.paymentStatus - b.paymentStatus,
  //   render: (text, record) => (
  //     <div>
  //       <div>{getPaymentDetailStatus(+text)}</div>
  //       <p className="mt-1 text-xs font-aileron font-semibold text-dark-gray">
  //         {record.paymentTimestamp
  //           ? dayjs(record.paymentTimestamp).format("DD-MM-YYYY")
  //           : ""}
  //       </p>
  //     </div>
  //   ),
  // },
  // {
  //   dataIndex: "id",
  //   width: "80px",
  //   render: (text, record) => (
  //     <button
  //       type="button"
  //       onClick={(event) => {
  //         event.stopPropagation();
  //       }}
  //       className="w-full flex items-center justify-center invisible group-hover:visible"
  //     >
  //       <ListDropdown detail={record} />
  //     </button>
  //   ),
  // },
];

const sessionColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Session ID
      </div>
    ),
    dataIndex: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Date
      </div>
    ),
    dataIndex: "endTime",
    sorter: (a, b) => a.endTime.localeCompare(b.endTime),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray py-1">
        {text ? dayjs(text).format("DD-MM-YYYY") : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Session Time
      </div>
    ),
    dataIndex: "sessionTime",
    // sorter: (a, b) => a.tripId - b.tripId,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text ? `${text}h` : "--"}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Energy Consumed
  //     </div>
  //   ),
  //   dataIndex: "id",
  //   // sorter: (a, b) => a.tripId - b.tripId,
  //   render: (text, record) => <EnergyConsumedColumn record={record} />,
  // },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       Amount/Energy Consumed
  //     </div>
  //   ),
  //   dataIndex: "id",
  //   // sorter: (a, b) => a.tripId - b.tripId,
  //   render: (text, record) => <AmountPerEnergyConsumedColumn record={record} />,
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Session Commission
      </div>
    ),
    dataIndex: "commissionAmount",
    sorter: (a, b) => a.commissionAmount - b.commissionAmount,
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray">
        {text ? `${text} KSH` : "--"}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Amount
      </div>
    ),
    dataIndex: "id",
    // sorter: (a, b) => sortByTotalAmount(a, b),
    render: (text, record) => <SessionTotalAmountColumn record={record} />,
  },
];

const useColumns = (selectedTab) => {
  if (selectedTab === DRIVER_OPERATION_TYPE.TRIP) return tripColumns;
  if (selectedTab === DRIVER_OPERATION_TYPE.SESSION) return sessionColumns;
  return [];
};

export default useColumns;
